import React from 'react'
import autoBind from '../utils/autoBind'
import styles from './SlopeSlider.module.css'

class SlopeSlider extends React.Component {
  constructor (props) {
    super(props)
    this.pos = 0
    this.start = 0
    this.state = {
      top: this.props.top
    }
    autoBind(['handleStart', 'handleTouchStart', 'handleDrag', 'handleEnd',
      'handleTouchEnd', 'handleNoop'], this)
  }

  UNSAFE_componentWillReceiveProps (nextProps) {
    if (this.props.top === nextProps.top) {
      return
    }
    this.setState({
      top: nextProps.top
    })
  }

  handleStart (e) {
    document.addEventListener('mousemove', this.handleDrag)
    document.addEventListener('mouseup', this.handleEnd)
    this.pos = this.state.top
    this.start = e.clientY
  }

  handleTouchStart (e) {
    document.addEventListener('touchmove', this.handleDrag)
    this.handleNoop(e)
    this.pos = this.state.top
    this.start = e.touches[0]['clientY']
    this.handleDrag(e)
  }

  handleDrag (e) {
    this.handleNoop(e)
    const coordinate = !e.touches ? e.clientY : e.touches[0]['clientY']
    let top = this.pos + coordinate - this.start
    top = Math.max(-1 * this.props.height - 15, top)
    top = Math.min(-15, top)
    this.props.onChange(top)
    this.setState({
      top: top
    })
  }

  handleEnd () {
    this.pos = this.slider.getBoundingClientRect().top
    document.removeEventListener('mousemove', this.handleDrag)
    document.removeEventListener('mouseup', this.handleEnd)
  }

  handleTouchEnd (e) {
    this.pos = this.slider.getBoundingClientRect().top
    this.handleNoop(e)
    document.removeEventListener('touchmove', this.handleDrag)
  }

  handleNoop (e) {
    e.stopPropagation()
    e.preventDefault()
  }

  render () {
    const { left } = this.props
    const { top } = this.state
    return (
      <div
        ref={(s) => { this.slider = s }}
        onMouseDown={this.handleStart}
        onTouchStart={this.handleTouchStart}
        onTouchEnd={this.handleTouchEnd}
        className={styles.slider} style={{ 'top': top, 'left': left }} />
    )
  }
}

// SlopeSlider.propTypes = {
//   top: PropTypes.number,
//   left: PropTypes.number,
//   height: PropTypes.number,
//   onChange: PropTypes.func
// }

export default SlopeSlider
